const { _satellite, kiwi } = window

const setPageCode = (pageCode: string) => {
  let applicationDataLayer = {
    page: {
      pageCode,
    },
  }

  try {
    kiwi.mergeDdl(applicationDataLayer)
  } catch (e: any) {
    if (typeof _satellite !== 'undefined') {
      _satellite.notify('Something went wrong with kiwi.mergeDDL(): ' + e.message)
    }
  }
}

export { setPageCode }
